import { Component, OnInit } from '@angular/core';
import { LoaderProvider } from '../../utils/providers/loader-provider';
import Swal from 'sweetalert2';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {
  sidenavLinks = [];

  constructor(
    private loader: LoaderProvider,
    private globalService: GlobalService,
  ) {
  }

  ngOnInit(): void {
    if (!sessionStorage.getItem('sidenavLinks')) {
      this.getSidenavLinks();
    } else {
      this.sidenavLinks = JSON.parse(sessionStorage.getItem('sidenavLinks'));
    }
  }

  getSidenavLinks(): any {
    this.loader.updateLoadingValue(true);
    const currentUser = JSON.parse(sessionStorage.getItem('page').replace(",]","]"))
    this.sidenavLinks = currentUser;
    sessionStorage.setItem('sidenavLinks', JSON.stringify(currentUser));
  }

  logout(): any {
    Swal.fire({
      title: `¿Desea cerrar sesión?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: `Cerrando sessión...`,
          text: 'Por favor espere',
          icon: 'warning',
          backdrop: false,
        });
        Swal.showLoading();
        this.globalService.logOut();
      }
    });
  }
}
